import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Router} from '@angular/router';
import { OrdensalidaService } from '../../../services/ordensalida.service';
import { StockService } from '../../../services/stock.service';
import { FilterUrlService } from '../../../services/filter-url.service';
import { LoadService } from '../../../services/load.service';
import { ProductsService } from '../../../services/products.service';
import { TagsService } from '../../../services/tags.service';
import { LocationService } from '../../../services/location.service';
import { Tags } from '../../../model/Tags';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {FormGroup,FormControl,Validators} from '@angular/forms';
import * as moment from 'moment';



@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class EditComponent implements OnInit {
  public id:number;
  public order:any;
  public tagsActuales:any[];
  public tagsNuevos:any[];
  public tagsNuevosHistorial:any[];
  public quitarTags:any[];
  public stock_list:any[];
  public meta:any;
  public links:any;
  public alert:string;
  public isopen:boolean;
  public mostrartabla:boolean;
  public modalRef:BsModalRef;
  public modalRef2:BsModalRef;
  public grupo_actual:any;
  public grupo_detalle:any;
  public tags_grupo_detalle:any[];
  public formDates:FormGroup;
  public modalRef3:BsModalRef;
  public settings = {
    columns:{
      // pr_code: {
      //   header: "Producto",
      //   type: "obj",
      //   filter: { visible:true,  id_type:'number', default:'asc', type:'dd' },
      // },
      pr_code: {
        header: "Producto",
        type: "text",
        filter: { visible:true,  id_type:'text', default:'asc', type:'text' },
      },
      pr_description:{
        header:"Descripción",
        type:"text",
        filter:{visible:true}
      },
      pr_group:{
        header:"Grupo",
        type:"text",
        filter:{visible:true}
      },
      lot_code: {
        header: "Lote",
        type:"text",
        filter: { visible:true }
      },
      pallet_code:{
        header:"Pallet",
        type:"text",
        filter:{visible:true}
      },
      location:{
        header:"Ubicación",
        type:"text",
        filter:{visible:true}
      },
      // },
      // location:{
      //   header:"Ubicación",
      //   type:"obj",
      //   path:"relationships.location.data.attributes.name",
      //   tipo:"ubicaciones",
      //   filter:{visible:true, default:'asc',type:'dd'}
      // },
      position:{
        header:"Posición",
        type:"text",
        filter:{visible:true}
      },
      elaboration_date: {
        header: "Fecha Elaboración",
        type:"date",
        filter: { visible:true }
      },
      total_box:{
        header:"Cajas Normales",
        type:"obj",
        tipo:"total",
        path:"relationships.tags.data.length",
        filter:{default:'asc'}
      },
      residue_box:{
        header:"Cajas Saldo",
        type:"text",
        filter:{visible:false}
      },
      total_normal_box:{
        header:"Total Kilos Normales",
        type:"text",
        filter:{visible:false}
      },
      total_residue:{
        header:"Total Kilos Saldo",
        type:"text",
        filter:{visible:false}
      },
      total:{
        header:"Total Kilos",
        type:"text",
        filter:{visible:false}
      }
    },
    actions:{
      edit: false,
      view: false,
      delete: false,
      close:false,
      detail:true,
    }
  };

  filter:string;



  constructor(private activatedRoute:ActivatedRoute,
              private ordenSalida:OrdensalidaService,
              private router:Router,
              private _stockService:StockService,
              private _filterUrlService:FilterUrlService,
              private _loaddata:LoadService,
              private _productsService:ProductsService,
              private _bsModalService:BsModalService,
              private _tagsService:TagsService,
              private _locationService:LocationService) {
    this.tagsActuales = [];
    this.stock_list = [];
    this.alert = '';
    this.isopen = true;
    this.mostrartabla = false;
    this.grupo_actual = {};
    this.grupo_detalle = {};
    this.tagsNuevos = [];
    this.tagsNuevosHistorial = [];
    this.quitarTags = [];
    this.tags_grupo_detalle = [];
    this._filterUrlService.changeFilters("");
    this.formDates = new FormGroup({
      'inicio_date':new FormControl('',Validators.required),
      'termino_date':new FormControl('',Validators.required)
    });
   }

  ngOnInit() {

    /*comprobando permisos*/
    let continuar = false;
    let roles = JSON.parse(localStorage.getItem('roles'));
    for(let rol of roles){
      if(rol.attributes.name === 'Gerente Planta' || rol.attributes.name === 'Desarrollo' || rol.attributes.name === 'Control de calidad'){
        continuar = true;
      }
    }

    if(continuar){
          this._filterUrlService.filters.subscribe(new_filter => this.filter = new_filter );
          this.activatedRoute.params.subscribe(params => {
           this.id = +params['id']; // (+) converts string 'id' to a number
           //console.log("ID RECIBIDA: ", this.id);
           // In a real app: dispatch action to load the details here.
           this.alert = 'Cargando Orden...';
           this.isopen = true;
           this._loaddata.loadChange(20);
           this.ordenSalida.getOne(this.id).subscribe((response:any)=>{
             this.order = response;
             //console.log("ORDEN: ",this.order);
             let status = this.order.relationships.status.data.id;
             //console.log("Status: ", status);
             /*si el estado es pendiente o preaprobada se puede editar*/
             //if(status === '1' || status === '5'){
               this.ordenSalida.getTagsOrder(this.order.id).subscribe((response:any)=>{
                 this.tagsActuales = response.data;
                 //console.log("TAGS DE ORDEN: ", response);
               },error=>{
                 console.log("No se han podido obtener las cajas asociadas a la orden", error.error.error);
               });
               //console.log("ORDEN: ", this.order);
               this.alert = 'Orden Cargada.';
               this.isopen = true;
               this._loaddata.loadChange(40);
               //this.loadUbicaciones();
               this.loadProductos();
             // }
             // else{
             //   this.volver();
             // }



           },error=>{
             this.volver();
             console.log("ERROR: ", error.error.error);
           });
        });
    }
    else{
      this.volver();
    }


   //this._filterUrlService.filterFirstLoad(this.settings);
  }

  volver(){
    this.router.navigate(['/solicitud']);
  }

  loadProductos(){
    this.alert = 'Cargando Productos...';
    this.isopen = true;
    this._loaddata.loadChange(40);

    this._productsService.getAll().subscribe(
      (response:any) => {
        let data = response.data;
        //console.log("DATA: ",data);
        let products:string = "{";
        for (var key in data) {
          //console.log("KEY: ", key);
          if (data.hasOwnProperty(key)) {
            products+='"'+data[key].attributes.code+'":"'+data[key].attributes.code+'",';
          }
        }
        products = products.slice(0,-1);
        products+="}";
        this.settings.columns.pr_code.filter['data'] = products;
        this.alert = "Productos Cargados.";
        this.isopen = true;
        this.mostrartabla = true;
        this._loaddata.loadChange(100);
        //this.loadStock();
      },
      (error) => {
        console.log("Error: ", error.error.error);
      }
    );
  }

  loadUbicaciones(){

    this._locationService.get().subscribe((response:any)=>{
      let data = response.data;
      let locations:string = "{";
            for (var key in data) {
              //console.log("KEY: ", key);
              if (data.hasOwnProperty(key)) {
                locations+='"'+data[key].id+'":"'+data[key].attributes.name+'",';
              }
            }
            locations = locations.slice(0,-1);
            locations+="}";
            this.settings.columns.location.filter['data'] = locations;
    },error=>{
      console.log("ERROR: ", error.error.error);
    });

  }

  loadStock(){
    this.alert = 'Cargando Stock Disponible...';
    this.isopen = true;
    this._loaddata.loadChange(60);
    this._stockService.getStockSummary().subscribe((response:any)=>{
      this.stock_list = response.data;
      //console.log("Stock Respuesta",this.stock_list);
      this.meta = response.meta;
      this.links = response.links;
      //console.log(this.stock_list, this.meta, this.links);
      this.alert = 'Stock Disponible Cargado.';
      this.isopen = true;
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();
    },error=>{
      console.log("ERROR AL CARGAR STOCK: ", error.error.error);
    })
  }

  /*busca los datos con respecto a los filtros seleccinados*/
  loadDataFiltered(filters){

    this.actualizarFiltroConFechas(filters);
    //console.log("URL LOAD DATA FILTERED: ", this.filter);
    //console.log('FILTROS: ', filters2);
    this.alert = 'Buscando Resultados...';
    this.isopen = true;
    this._loaddata.loadChange(40);
    this._stockService.getDataFiltered(this.filter).subscribe(
      (response:any) => {
        //console.log("Respuesta del filtro", response);
        this.stock_list = response.data;
        // for(let c of this.stock_list){
        //   c.attributes.select = false;
        // }
        // this.stock_list = this.formatDate(this.stock_list);
        this.links = response.links;
        this.meta = response.meta;

        this._loaddata.loadChange(100);
        this.alert = "Carga Correcta."
        this.isopen =true;
        this.onClosedAutomatic();
      },
      (error) => {
        if(error.status == 0){
          this.alert = 'Busqueda sin resultados.';
          this.onClosedAutomatic();
        }
        else{
          console.log("ERROR: ",error.error.error);
        }
      }
    );
  }

  actualizarFiltroConFechas(filters){
    //console.log("filtro recibido",filters);
    let filtro_nuevo = ``;
    let from = this.formDates.get('inicio_date').value;
    let to = this.formDates.get('termino_date').value;
    let f = moment(from).format("YYYY-MM-DD");
    let t = moment(to).format("YYYY-MM-DD");
    //console.log("From: ",from);
    //console.log("To: ",to);

    if(filters.length > 0){
      /*si el filtro ya contiene parametros*/
      let contain_symbol  = filters.includes('?from=');
      let contain_griega = filters.includes('&from=');
      if(contain_symbol){
        /*si contiene el simbolo de interrogación seguido del from (quiere decir que no hay ningun filtro mas que las fechas)*/
        if(!filters.includes('&enabled=1')){
          filtro_nuevo = `?from=${f}&to=${t}&enabled=1`;
        }
        else{
          filtro_nuevo = `?from=${f}&to=${t}`;
        }

        this._filterUrlService.changeFilters(filtro_nuevo);
        //console.log("FILTRO SOLO CON FECHAS:",this.filter);
      }
      else if(contain_griega){
        /*si ya contiene un rango de fechas*/
        //console.log("SI AQUI");
        /*separando el &from*/
        let array_from = filters.split("&from=");
        let parte_1 = array_from[0];
        let fin_parte_2 = array_from[1].length;
        let parte_2 = array_from[1].slice(10,fin_parte_2);

        let filtro_from_actualizado = `${parte_1}&from=${f+parte_2}`;
        //console.log("filtro from actualizado:",filtro_from_actualizado);
        /*separando el &to*/
        let array_to = filtro_from_actualizado.split("&to=");
        let parte_1_final = array_to[0];
        let fin_parte_2_final = array_to[1].length;
        let parte_2_final = array_to[1].slice(10,fin_parte_2_final);
        if(!filters.includes('&enabled=1')){
            filtro_nuevo = `${parte_1_final}&to=${t+parte_2_final}&enabled=1`;
        }
        else{
          filtro_nuevo = `${parte_1_final}&to=${t+parte_2_final}`;
        }

        this._filterUrlService.changeFilters(filtro_nuevo);
        //console.log("FECHAS ACTUALIZADAS",this.filter);

      }
      else{
        /*no contiene un rango de fechas pero si tiene filtros aplicados*/
        if(f != 'Invalid date' && t != 'Invalid date'){

          if(!filters.includes('&enabled=1')){
            filtro_nuevo = `${filters}&from=${f}&to=${t}&enabled=1`;
          }
          else{
            filtro_nuevo = `${filters}&from=${f}&to=${t}`;
          }

          this._filterUrlService.changeFilters(filtro_nuevo);
          //console.log("FILTRO NO TIENE RANGO FECHAS PERO SI FILTROS:",this.filter);
        }
        else{
          if(!filters.includes('&enabled=1')){
            filtro_nuevo = `${filters}&enabled=1`;
            this._filterUrlService.changeFilters(filtro_nuevo);
            //console.log("FILTRO CUANDO NO HAY RANGO DE FECHAS",this.filter);
          }
        }

      }
    }
    else{
      /*el filtro no contiene parametros*/

      if(!filters.includes('&enabled=1')){
        filtro_nuevo = `?from=${f}&to=${t}&enabled=1`;
      }
      else{
        filtro_nuevo = `?from=${f}&to=${t}`;
      }

      this._filterUrlService.changeFilters(filtro_nuevo);
      //console.log("FILTRO VACIO:",this.filter);
    }






    // if(filters.length > 0){
    //
    //   let contain_from = this.filter.includes('&from=');
    //   let contain_to = this.filter.includes('&to=');
    //
    //   if(contain_from == true){
    //
    //         if(from != ''){
    //           let format_1 = moment(from).format("YYYY-MM-DD");
    //           console.log('fecha nueva from: &from= :',format_1);
    //           let array = this.filter.split('&from=');
    //           let filter1 = array[0];
    //           //console.log('antes from: ',array[0]);
    //           //console.log('despues from: ',array[1]);
    //           let fin = array[1].length;
    //           let filter2 = array[1].slice(10,fin);
    //
    //           //this.filter = `${filter1}&from=${format_1+filter2}`;
    //           filtro = `${filter1}&from=${format_1+filter2}`;
    //           this._filterUrlService.changeFilters(filtro);
    //           console.log("filtro contain_from: ",this.filter);
    //           //console.log('filtro nuevo from',this.filter);
    //         }
    //
    //   }
    //   else if(from != ''){
    //     let format_2 = moment(from).format("YYYY-MM-DD");
    //     let contain_symbol_from = filters.includes('?from=');
    //
    //     if(contain_symbol_from == true){
    //       let ar = this.filter.split('from=');
    //       /*fil1 contiene el simbolo de ?*/
    //       let fil1=ar[0];
    //       let fi=ar[1].length;
    //       let fil2=ar[1].slice(11,fi);
    //       //this.filter = `${fil1}from=${format_2+fil2}`;
    //       filtro = `${fil1}from=${format_2+fil2}`;
    //       this._filterUrlService.changeFilters(filtro);
    //       console.log("filtro contain_symbol_from: ",this.filter);
    //       console.log("filtro filtro:",filtro);
    //
    //     }
    //     else{
    //       filtro = this.filter+=`&from=${format_2}`;
    //       this._filterUrlService.changeFilters(filtro);
    //       console.log("filtro contain_symbol_else_from: ",this.filter);
    //     }
    //
    //
    //   }
    //
    //   if(contain_to == true){
    //     if(to != ''){
    //       let to_format_1 = moment(to).format("YYYY-MM-DD");
    //       let array = filters.split('&to=');
    //       let filter3 = array[0];
    //       //console.log('antes from: ',array[0]);
    //       //console.log('despues from: ',array[1]);
    //       let fin = array[1].length;
    //       let filter4 = array[1].slice(10,fin);
    //
    //       //this.filter = `${filter3}&to=${to_format_1+filter4}`;
    //       filtro = `${filter3}&to=${to_format_1+filter4}`;
    //       this._filterUrlService.changeFilters(filtro);
    //       //console.log('filtro nuevo To',this.filter);
    //     }
    //   }
    //   else if(to != ''){
    //     let to_format_2 = moment(to).format("YYYY-MM-DD");
    //     //this.filter+=`&to=${to_format_2}`;
    //     filtro +=`&to=${to_format_2}`;
    //     //this._filterUrlService.changeFilters(filtro);
    //   }
    // }
    // else{
    //
    //   if(from != ''){
    //     let from_format = moment(from).format("YYYY-MM-DD");
    //     //this.filter =`?from=${from_format}`;
    //     filtro = `?from=${from_format}`;
    //     this._filterUrlService.changeFilters(filtro);
    //   }
    //
    //   if(to != '' && from == ''){
    //     let to_format = moment(to).format("YYYY-MM-DD");
    //     //this.filter=`?to=${to_format}`;
    //     filtro = `?to=${to_format}`;
    //     //this._filterUrlService.changeFilters(filtro);
    //   }
    //   else if(to != '' && from != ''){
    //     let to_format = moment(to).format("YYYY-MM-DD");
    //     //this.filter+=`&to=${to_format}`;
    //     filtro = this.filter+=`&to=${to_format}`;
    //     //this._filterUrlService.changeFilters(filtro);
    //   }
    // }
    //
    // this._filterUrlService.changeFilters(filtro);
    // console.log('FILTRO FINAL CON FECHAS:',filtro);
    // return filtro;
  }

  updateData(response:any){
    //console.log("Respuesta Actualización: ", response);
    this.stock_list = response.data;
    this.meta = response.meta;
    this.links = response.links;
  }

  mostrarDetalle(grupo:any,template: TemplateRef<any>){
    this.grupo_actual = grupo;
    //console.log("Grupo seleccionado: ", this.grupo_actual);
    for(let tag of this.grupo_actual.relationships.tags.data){
      for(let item of this.tagsNuevosHistorial){
        if(item.tag_id === tag.id){
          //console.log("Entro");
          tag.attributes.added = true;
        }
      }
    }
    this.modalRef = this._bsModalService.show(template);
  }

  cerrarModal(){
    this.modalRef.hide();
    //this.grupo_actual = {};
  }

  agregarTag(tag_id:number, index:number){
    //console.log("Tag_id: ", tag_id);
    this.tagsNuevos.push({
      'tag_id':tag_id
    });
    this.tagsNuevosHistorial.push({
      'tag_id':tag_id
    });
    // for(let tag of this.grupo_actual.relationships.tags.data){
    //   for(let item of this.tagsNuevosHistorial){
    //     if(item.tag_id === tag.id){
    //       console.log("Entro");
    //       tag.attributes.added = true;
    //     }
    //   }
    // }

    let tag = new Tags(0,0,0,0,0,0,0,0,0,0,0,0,0,0);
    let body = tag.getJsonOrdenSalida(this.tagsNuevos, this.order.id);
    //console.log("Body: ", body);
    this._tagsService.update(body).subscribe((response:any)=>{
      this.tagsNuevos = [];
      //console.log("respuesta tags agregados", response);
      this.grupo_actual.relationships.tags.data.splice(index,1);
      if(this.grupo_actual.relationships.tags.data.length == 0){
        this.cerrarModal();
        let index = this.grupo_actual.index;
        this.stock_list.splice(index,1);
      }

      this.getOrder();
      this.ordenSalida.getTagsOrder(this.order.id).subscribe((response:any)=>{
        this.tagsActuales = response.data;
        //console.log("TAGS DE ORDEN: ", response);
      },error=>{
        console.log("No se han podido obtener las cajas asociadas a la orden", error.error.error);
      });

    },error=>{
      console.log("No se han agregado los tags a la orden", error.error.error);
    });
  }

  getOrder(){
    this.ordenSalida.getOne(this.order.id).subscribe((response:any)=>{
      this.order = response;
    },error=>{
      console.log("ERROR: ",error.error.error);
    });
  }

  agregarTodos(){
    for(let tag of this.grupo_actual.relationships.tags.data){

      this.tagsNuevos.push({
           'tag_id':tag.id
      });
    }



    if(this.tagsNuevos.length > 0){
      let tag = new Tags(0,0,0,0,0,0,0,0,0,0,0,0,0,0);
      let body = tag.getJsonOrdenSalida(this.tagsNuevos, this.order.id);
      //console.log("Body: ", body);
      this._tagsService.update(body).subscribe((response:any)=>{
        //console.log("respuesta tags agregados", response);
        this.cerrarModal();
        let index = this.grupo_actual.index;
        this.stock_list.splice(index,1);
        this.getOrder();
        this.ordenSalida.getTagsOrder(this.order.id).subscribe((response:any)=>{
        this.tagsActuales = response.data;
          //console.log("TAGS DE ORDEN: ", response);
        },error=>{
          console.log("No se han podido obtener las cajas asociadas a la orden", error.error.error);
        });

      },error=>{
        console.log("No se han agregado los tags a la orden", error.error.error);
      });
    }

  }

  detalleGrupo(grupo:any,template2: TemplateRef<any>){
    //console.log("GRUPO: ", grupo.relationships.tags.data.length);
    this.grupo_detalle = grupo;
    this.tags_grupo_detalle = grupo.relationships.tags.data;
    //console.log("GRUPO DETALLE: ", this.grupo_detalle);
    this.modalRef2 = this._bsModalService.show(template2);
  }

  cerrarModal2(){
    this.modalRef2.hide();
    //this.grupo_actual = {};
  }

  onClosedAutomatic(){
    setTimeout(()=>{
      this.isopen = false;
      this.alert = '';
    },3000)
  }

  onClosed(){
    this.isopen = false;
  }

  quitarTag(tag_id, index:number){
    let tag = {
      'tag_id':tag_id
    }



    this.quitarTags.push(tag);
    let t = new Tags(0,0,0,0,0,0,0,0,0,0,0,0,0,0);
    let body = t.getJsonOrdenSalidaQuitar(this.quitarTags);
    this._tagsService.update(body).subscribe((response:any)=>{
      //console.log("Respuesta quitar tag", response);
      this.quitarTags = [];
      this.getOrder();
      this.grupo_detalle.relationships.tags.data.splice(index,1);
      if(this.grupo_detalle.relationships.tags.data.length == 0){
        this.cerrarModal2();
      }
      this.ordenSalida.getTagsOrder(this.order.id).subscribe((response:any)=>{
      this.tagsActuales = response.data;
      },error=>{
        console.log("No se ha podido cargar la orden después de quitar el tag");
      })
    },error=>{
      console.log("No se ha podido quitar el Tag", error.error.error);
    });
  }

  quitarTodos(grupo:any){
    this.alert = 'Quitando las Cajas de la Orden...';
    this.isopen = true;
    this._loaddata.loadChange(20);
    for(let ta of this.grupo_detalle.relationships.tags.data){
      let tag = {
        'tag_id':ta.id
      }
      this.quitarTags.push(tag);
    }

   let t = new Tags(0,0,0,0,0,0,0,0,0,0,0,0,0,0);
   let body = t.getJsonOrdenSalidaQuitar(this.quitarTags);

   this._tagsService.update(body).subscribe((response:any)=>{
     //console.log("Respuesta quitar tag", response);
     this.getOrder();
     this.alert = 'Cajas Quitadas...';
     this.isopen = true;
     this._loaddata.loadChange(40);
     this.quitarTags = [];
     this.ordenSalida.getTagsOrder(this.order.id).subscribe((response:any)=>{
       this.alert = 'Cajas de orden Actualizada.';
       this.isopen = true;
       this._loaddata.loadChange(100);
       this.onClosedAutomatic();
       this.tagsActuales = response.data;
       this.cerrarModal2();
     },error=>{
       console.log("No se ha podido cargar la orden después de quitar el tag");
     });
   },error=>{
     console.log("No se ha podido quitar el Tag", error.error.error);
   });
  }

  // public iniciarFiltro(parameter) {
  //   let columns:any = this.settings['columns'];
  //   for(let key in columns){
  //     if (columns.hasOwnProperty(key) && columns[key].ignored != true) {
  //       if(columns[key]['filter']['default'] == 'desc' && columns[key]['filter']['default'] != 'undefined'){
  //         this.filter['sort'][key] = "desc";
  //       }
  //       else{
  //         this.filter['sort'][key] = (columns[key]['sort'] === 'undefined')?columns[key]['sort']['default']:"asc";
  //       }
  //       this.filter['values'][key]='';
  //     }
  //   }
  // }

  public filtrarFecha(){

    this.loadDataFiltered(this.filter);
    // console.log("fecha from: ",this.formDates.get('inicio_date').value);
    // let filters3 = this.actualizarFiltroConFechas(this.filter);
    // this._filterUrlService.changeFilters(filters3);
    // console.log('filtro Actualizado: ',filters3);
    // this.alert = 'Buscando Resultados...'
    // this.isopen = true;
    // this._loaddata.loadChange(40);
    // setTimeout(()=>{
    //   this._stockService.getDataFiltered(filters3).subscribe(
    //     (response:any) => {
    //       //console.log("Respuesta desde boton buscar", response);
    //       this.stock_list = response.data;
    //       // for(let c of this.stock_list){
    //       //   c.attributes.select = false;
    //       // }
    //       // this.stock_list = this.formatDate(this.stock_list);
    //       this.links = response.links;
    //       this.meta = response.meta;
    //
    //       this._loaddata.loadChange(100);
    //       this.alert = "Carga Correcta."
    //       this.isopen =true;
    //       this.onClosedAutomatic();
    //     },
    //     (error) => {
    //       if(error.status == 0){
    //         this.alert = 'Busqueda sin resultados.';
    //         this.onClosedAutomatic();
    //       }
    //       else{
    //         console.log("ERROR: ",error.error.error);
    //       }
    //     }
    //   );
    // },3000);

  }

  enviarOrden(){
    //console.log("Orden a Enviar: ", id);
    let body = this.ordenSalida.transformDataUpdateStatusToRevision(this.order.id);
    this.ordenSalida.updateStateToRevision(body,this.order.id).subscribe((response:any)=>{
      //console.log("respuesta: ", response);
      this.cerrarModalEnviar();
      this.volver();
    },error=>{
      console.log("No se ha podido enviar la orden: ", error.error.error);
    });
  }

  mostrarEnviarOrden(template:TemplateRef<any>){
    this.modalRef3 = this._bsModalService.show(template);
  }

  cerrarModalEnviar(){
    this.modalRef3.hide();
  }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/solicitudmovimiento/edit/edit.component.ts